export default __webpack_public_path__ + "static/media/cedeshero.f211f95b.jpg";